import { render, staticRenderFns } from "./menu3_video_clip_q.vue?vue&type=template&id=aeddd10e&scoped=true"
import script from "./menu3_video_clip_q.vue?vue&type=script&lang=js"
export * from "./menu3_video_clip_q.vue?vue&type=script&lang=js"
import style0 from "./menu3_video_clip_q.vue?vue&type=style&index=0&id=aeddd10e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeddd10e",
  null
  
)

export default component.exports